import { render, staticRenderFns } from "./resultsContainer.vue?vue&type=template&id=0c524675&scoped=true"
import script from "./resultsContainer.vue?vue&type=script&lang=js"
export * from "./resultsContainer.vue?vue&type=script&lang=js"
import style0 from "./resultsContainer.vue?vue&type=style&index=0&id=0c524675&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c524675",
  null
  
)

export default component.exports